<template>
<div>
    <v-layout >
        <v-flex 
          xs12 outline >
            <div 
            style="
              margin-top:-1rem;
              border:dashed;
              border-width: 0.1rem;
              padding:1rem;">
            <v-icon color="orange">error</v-icon> 
            If you want a plug&play experience or you have already setup asset-tracking dashboard and TTN web service, please follow just last two steps of this guide
            </div>
        </v-flex>
    </v-layout>

  <v-timeline>
    <v-timeline-item
      color="#002052"
      fill-dot
      left
      
    >
      <v-card>
        <v-card-title class=" justify-end" style="background-color:#002052">
          <h2 class="title white--text font-weight-light">Get device EUI</h2>
        </v-card-title>
        <v-container>
          <v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                1. Flash FP-ATR-LORA1 firmware binary and connect device to the PC via USB
                </v-flex>
                <v-flex xs12>
                2. Open serial terminal (e.g. TeraTerm) to inspect device log
                </v-flex>
                <v-flex xs12>
                  <img
                    style="width:100%" 
                    src="@/assets/howto/serialportsetup.png" />
                </v-flex>
                <v-flex xs12>
                3. Read and <b>get device EUI</b>
                </v-flex>
                <v-flex xs12>
                  <img
                    style="width:100%" 
                    src="@/assets/howto/deviceeui.png" />
                </v-flex>
              </v-layout>
          </v-layout>
        </v-container>
      </v-card>
    </v-timeline-item>


    <v-timeline-item
      color="#002052"
      fill-dot
      right
    >
      <v-card>
        <v-card-title  style="background-color:#002052">
          <v-icon
            dark
            size="42"
            class="mr-3"
          >
            mdi-magnify
          </v-icon>
          <h2 class="title white--text font-weight-light">Setup TTN</h2>
        </v-card-title>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12>
              1. Create an account on <a href="https://account.thethingsnetwork.org/users/login">TTN console web service</a>
            </v-flex>
            <v-flex xs12>
              2. Create an application and get the auto-generated <b>Application EUI</b>
            </v-flex>
              <v-flex xs12 style=";text-align:center" >
                <img
                style="width:100% ;text-align:center" 
                src="@/assets/howto/ttncreateapp3.png" />
              </v-flex>
              <v-flex xs12>
                3. Create and get <b>TTN api-key</b> with all permissions
              </v-flex>
               <v-flex xs12 style=";text-align:center" >
                  <img
                  style="width:100% ;text-align:center" 
                  src="@/assets/howto/ttncreateapikey.png" />
                </v-flex>
              <v-flex xs12>
                4. Get <b>region prefix of TTN handler</b> (e.g. in this case <b>eu</b>)
              </v-flex>
               <v-flex xs12 style=";text-align:center" >
                  <img
                  style="width:100% ;text-align:center" 
                  src="@/assets/howto/ttnhandler.png" />
                </v-flex>
              <v-flex xs12>
                5. Create and get an <b>asset-tracking api-key</b> from this dashboard
              </v-flex>
               <v-flex xs12 style=";text-align:center" >
                  <img
                  style="width:100% ;text-align:center" 
                  src="@/assets/howto/assettrackingapikey.png" />
                </v-flex>
              <v-flex xs12>
                6. Create application HTTP integration with 
                <ul>
                  <li>URL: <a>https://{{http.host}}/{{http.basePath}}/data?nostd=true</a></li>
                  <li>Authorization: set <b>asset-tracking api-key</b> previously created </li>
                </ul>
              </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-timeline-item>

    <v-timeline-item
      color="#002052"
      fill-dot
      left
    >
      <v-card>
        <v-card-title style="background-color:#002052">
          <v-icon
            class="mr-3"
            dark
            size="42"
          >
            mdi-email-outline
          </v-icon>
          <h2 class="title white--text font-weight-light">Create TTN LoRa device profile</h2>
        </v-card-title>
        <v-container>
          <v-layout  row wrap>
            <v-flex xs12>
              In order to simplify the device provisioning, create a TTN LoRa device profile in this dashboard by using parameters previously got 
              (TTN Region handler, application ID, application EUI, TTN Api-key). Note: a default <b>application key</b> is already provided, it will be need in next steps
            </v-flex>
            <v-flex xs12 style="text-align:center">
              <img style="width:100%" src="@/assets/howto/assettrackingttnloradeviceprofile.png" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-timeline-item>


    <v-timeline-item
      color="#002052"
      fill-dot
      left
    >
      <v-card>
        <v-card-title style="background-color:#002052">
          <v-icon
            class="mr-3"
            dark
            size="42"
          >
            mdi-email-outline
          </v-icon>
          <h2 class="title white--text font-weight-light">Register device</h2>
        </v-card-title>
        <v-container>
          <v-layout row wrap>
              <v-flex xs12 >
                Register device inserting a human-friendly device label, device EUI and device profile (default or the previous one created)
              </v-flex>
              <v-flex>
                <img style="width:100%" src="@/assets/howto/registerloradevice.png" />
              </v-flex>
            </v-layout>
        </v-container>
      </v-card>
    </v-timeline-item>


    <v-timeline-item
      color="#002052"
      fill-dot
      left
    >
      <v-card>
        <v-card-title style="background-color:#002052">
          <v-icon
            class="mr-3"
            dark
            size="42"
          >
            mdi-email-outline
          </v-icon>
          <h2 class="title white--text font-weight-light">Configure device</h2>
        </v-card-title>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 >
              Configure physical device via serial terminal by seting parameters previously got:
              <ul>
                  <li>
                    Set join eui (<code>!joineui-xxxxxxxxxxxxxxx</code> , replacing x characthers with application eui value)
                  </li>
                  <li>
                    Set network key (<code>!ntwkkey-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</code> , replacing x characthers with application key value)
                  </li>
                  <li>
                    Set application key (<code>!appkey-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</code> , replacing x characthers with application key value)
                  </li>
              </ul>
              </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-timeline-item>


  </v-timeline>
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  }
}
</script>